import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Row, Col, Form, Button, Table, Modal } from 'react-bootstrap';
import * as Common from '../../Common';


function Ad1ActivityLog(props) {
    const sid = sessionStorage.getItem('sessionId');
    const [logListData, setLogListData] = useState([]);


    useEffect(() => {
        Common.callApi(Common.apiAd1, [sid, 'activityLog', JSON.stringify({ srno: props.srno })], function (result) {
            let resp = JSON.parse(result);
            console.log(resp);
            setLogListData(resp);
        });
        // Common.callApi(Common.apiRight, [sid, 'all', 'AD1COVERRATE'], function (result1) {
        //     setCoverRight(JSON.parse(result1));
        // });
    }, []);



    return (
        <>
            <div className="divCostumForm">
                <Container fluid>
                    <Row>
                        <Col>
                            <h3>Activity Log</h3>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Table responsive striped bordered hover>
                                <thead>
                                    <tr>
                                        <td>Time Stamp</td>
                                        <td>User Name</td>
                                        <td>Remark</td>
                                    </tr>
                                </thead>
                                <tbody>

                                    {logListData.map((res) =>
                                        <tr key={res.reqlog_rndnum}>
                                            <td>{res.reqlog_logtime}</td>
                                            <td>{res.um_username}</td>
                                            <td>{res.reqlog_rmk}</td>
                                        </tr>
                                    )}
                                </tbody>
                            </Table>

                        </Col>
                    </Row>
                </Container>
            </div>

        </>
    )
}
export default Ad1ActivityLog;